<template>
  <div>
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Datum</th>
        <th>Project</th>
        <th>Bedrag</th>
        <th>Link</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="benefit in benefits">
        <td>{{benefit.date}}</td>
        <td><a class="hoverable" @click="$router.push({ name: 'projects.view', params: { id: benefit.project_id} })">{{benefit.project_name}}</a></td>
        <td>{{benefit.amount}}</td>
        <td><a :href="benefit.link" target="_blank">Bekijk in SalesForce</a></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'account-benefits',
  props: ['benefits'],
}
</script>
